import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const colorMap = {
  normal: "#22c55e",   // green
  warning: "#eab308",  // yellow
  critical: "#ef4444"  // red
};

const WorkOrderTimeline = ({ data = [] }) => {
  const ref = useRef();

  useEffect(() => {
    if (!data.length) return;

    const svg = d3.select(ref.current);
    svg.selectAll("*").remove();

    const margin = { top: 40, right: 10, bottom: 30, left: 10 }; // reduced top and bottom margins
    const width = data.length * 120;
    const height = 160 - margin.top - margin.bottom; // reduced total height

    const parseTime = d3.timeParse("%m’%y");
    const formatTime = d3.timeFormat("%m’%y");

    const dates = data.map((d) => parseTime(d.date));
    // const xScale = d3.scaleTime()
    //   .domain(d3.extent(dates))
    //   .range([30, width - 30]);

    const xScale = d3.scaleTime()
      .domain(d3.extent(dates))
      .range([30, 260 + data.length * 40]);

    const svgContainer = svg
      .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
      .attr("preserveAspectRatio", "xMidYMid meet")
      .style("overflow", "visible")
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    svgContainer.append("g")
      .attr("transform", `translate(0,${height})`)
      .call(d3.axisBottom(xScale).tickFormat(formatTime).ticks(data.length))
      .selectAll("text")
      .attr("font-size", "12px");

    const tooltip = d3.select("body")
      .append("div")
      .style("position", "absolute")
      .style("background", "#fff")
      .style("border", "1px solid #ccc")
      .style("padding", "8px")
      .style("font-size", "12px")
      .style("border-radius", "4px")
      .style("pointer-events", "none")
      .style("opacity", 0);

    // data.forEach((entry) => {
    //   const x = xScale(parseTime(entry.date));

    //   entry.orders.forEach((order, index) => {
    //     const y = 10 + index * 28; // slightly tighter vertical spacing

    //     svgContainer.append("line")
    //       .attr("x1", x)
    //       .attr("x2", x)
    //       .attr("y1", -10)
    //       .attr("y2", -10)
    //       .attr("stroke", "#d1d5db")
    //       .attr("stroke-dasharray", "4")
    //       .transition()
    //       .duration(600)
    //       .ease(d3.easeCubicOut)
    //       .attr("y2", height);

    //     svgContainer.append("circle")
    //       .attr("cx", x)
    //       .attr("cy", -10)
    //       .attr("r", 6)
    //       .attr("fill", colorMap[order.type] || "#9ca3af")
    //       .on("mouseover", function (event) {
    //         tooltip.transition().duration(200).style("opacity", 0.9);
    //         tooltip.html(
    //           `<strong>ID:</strong> ${order.id}<br/><strong>Components:</strong> ${order.components.join(", ")}<br/><strong>Type:</strong> ${order.type}`
    //         ).style("left", `${event.pageX + 10}px`).style("top", `${event.pageY - 28}px`);
    //       })
    //       .on("mouseout", () => {
    //         tooltip.transition().duration(300).style("opacity", 0);
    //       })
    //       .transition()
    //       .duration(500)
    //       .ease(d3.easeBackOut)
    //       .attr("cy", y);

    //     svgContainer.append("text")
    //       .attr("x", x)
    //       .attr("y", y + 20)
    //       .attr("text-anchor", "middle")
    //       .attr("font-size", "10px")
    //       .attr("font-weight", "bold")
    //       .text(order.id);

    //     svgContainer.append("text")
    //       .attr("x", x)
    //       .attr("y", y + 30)
    //       .attr("text-anchor", "middle")
    //       .attr("font-size", "8px")
    //       .attr("fill", "#4b5563")
    //       .text(order.components.join(", "));
    //   });
    // });


data.forEach((entry) => {
  const x = xScale(parseTime(entry.date));

  // Always render the vertical dotted line
  svgContainer.append("line")
    .attr("x1", x)
    .attr("x2", x)
    .attr("y1", -10)
    .attr("y2", -10)
    .attr("stroke", "#d1d5db")
    .attr("stroke-dasharray", "4")
    .transition()
    .duration(600)
    .ease(d3.easeCubicOut)
    .attr("y2", height);

  // Only render orders if they exist
  if (entry.orders && entry.orders.length) {
    entry.orders.forEach((order, index) => {
      const y = 10 + index * 28;

      svgContainer.append("circle")
        .attr("cx", x)
        .attr("cy", -10)
        .attr("r", 6)
        .attr("fill", colorMap[order.type] || "#9ca3af")
        .on("mouseover", function (event) {
          tooltip.transition().duration(200).style("opacity", 0.9);
          tooltip.html(
            `<strong>ID:</strong> ${order.id}<br/><strong>Components:</strong> ${order.components.join(", ")}<br/><strong>Type:</strong> ${order.type}`
          ).style("left", `${event.pageX + 10}px`).style("top", `${event.pageY - 28}px`);
        })
        .on("mouseout", () => {
          tooltip.transition().duration(300).style("opacity", 0);
        })
        .transition()
        .duration(500)
        .ease(d3.easeBackOut)
        .attr("cy", y);

      svgContainer.append("text")
        .attr("x", x)
        .attr("y", y + 20)
        .attr("text-anchor", "middle")
        .attr("font-size", "10px")
        .attr("font-weight", "bold")
        .text(order.id);

      svgContainer.append("text")
        .attr("x", x)
        .attr("y", y + 30)
        .attr("text-anchor", "middle")
        .attr("font-size", "8px")
        .attr("fill", "#4b5563")
        .text(order.components.join(", "));
    });
  }
});


    return () => tooltip.remove();
  }, [data]);

  return (
    <div className="rounded border border-gray-300 p-4 bg-white mt-2">
      <h2 className="text-sm font-semibold text-gray-700 mb-2 v_health_blocks_heading">Work Orders (Last 6 Months)</h2>
      <div className="overflow-hidden">
        <div className="min-w-[800px]">
          <svg ref={ref} className="w-full h-auto" />
        </div>
      </div>
    </div>
  );
};

export default WorkOrderTimeline;
